import React, { FC, useContext } from 'react'
import { Layout } from '@sistemiv/s-components'
import DashboardSwitch from '../components/dashboard/DashboardSwitch'
import TopNav from '../components/nav/TopNav'
import SideNav from '../components/nav/SideNav'
import { createSignalRContext } from 'react-signalr'
import { OrganizationsContext } from '../context/OrganizationsContext'

export const SignalRContext = createSignalRContext()

export const refreshUsersEvents = [
  'MembershipDeactivatedEvent',
  'MembershipActivatedEvent',
  'MembershipDeletedEvent',
  'UserInvitedEvent',
  'InvitationAcceptedEvent',
  'InvitationExpiredEvent',
  'MembershipRejectedEvent',
  'MembershipSetToInvitationSentEvent',
  'UserInvitedEvent',
  'UserApprovedEvent',
  'UserJoinRequestedEvent',
]

export const groupsEvents = ['UserAddedToGroupEvent', 'UserGroupDeletedEvent', 'UserRemovedFromGroupEvent']
export const nodesEvents = ['OrganizationNodeDeletedEvent']
//export const nodesEvents = ['OrganizationNodeDeletedEvent', 'UserAddedToOrganizationNodeEvent']

const Dashboard: FC = () => {
  // const { org } = useParams()
  // const [token, setToken] = useState('')
  // const { userId } = useAuth()
  // const { setOrganizations, isLoadingOrganizations } = useContext(OrganizationsContext)
  // const { setApplications, setProfileApps } = useContext(ApplicationsContext)

  // TODO implement sockets to work with Ory auth provider
  // SignalRContext.useSignalREffect(
  //   'sync',
  //   //@ts-ignore
  //   (payload, data) => {
  //     if (AUTH_PROVIDER !== 'msal') return
  //     if (
  //       ['MembershipActivatedEvent', 'InvitationAcceptedEvent', 'UserApprovedEvent'].includes(payload) &&
  //       data.UserId === userId
  //     ) {
  //       UserService?.listOrganizations().then((response) => setOrganizations(response.organizations))
  //     }
  //     if (['AppAccessDeniedToUserEvent', 'AppAccessAddedToUserEvent'].includes(payload) && data.UserId === userId) {
  //       if (!org) return
  //       UserService.listApplications(org).then(setApplications)
  //       ProfileService.getApplications(org, userId!).then((data) => setProfileApps(data?.applications))
  //     }
  //   },
  //   [],
  // )

  // return (
  //   <SignalRContext.Provider
  //     connectEnabled={!!token}
  //     accessTokenFactory={() => {
  //       const account = instance.getActiveAccount()
  //       if (account) {
  //         const accessTokenRequest = {
  //           scopes: ['fd1442d1-cbcc-4b73-a893-a61b8d3d4782'],
  //           account: account,
  //         }
  //         const newToken = instance.acquireTokenSilent(accessTokenRequest).then((response) => response.accessToken)
  //         return newToken
  //       }
  //       return token
  //     }}
  //     dependencies={[token]} //remove previous connection and create a new connection if changed
  //     url={`https://${getBaseUrl()}/s-notifications/api/${org}/real-time-updates`}
  //   >
  //     {/* // <ErrorHandlingInterceptor> */}
  //     <Layout topNavComponent={<TopNav />} sideMenuComponent={<SideNav />}>
  //       <DashboardSwitch />
  //     </Layout>
  //     {/* </ErrorHandlingInterceptor> */}
  //   </SignalRContext.Provider>

  const { isLoadingOrganizations } = useContext(OrganizationsContext)
  return (
    <div className={isLoadingOrganizations ? 'opacity-50 pointer-events-none select-none' : ''}>
      <Layout topNavComponent={<TopNav />} sideMenuComponent={<SideNav />}>
        <DashboardSwitch />
      </Layout>
    </div>
  )
}

export default Dashboard
